import { useEffect, useState } from 'react';
import { supabase } from '../supabase';
import { buildApiUrl } from '../utils/apiUrl';
import { useEmpresaId } from '../context/EmpresaContext';

// Para pantallas que solo debe poder usar el Super Usuario (ej. Sync VFP,
// que puede sobrescribir datos transaccionales del ERP). Los permisos de
// app_roles no alcanzan aquí — es_superusuario es un flag aparte en la
// tabla usuarios, el mismo que ya exige el backend en vfp-sync.js.
export function useEsSuperUsuario() {
  const empresaId = useEmpresaId();
  const [esSuperUsuario, setEsSuperUsuario] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let activo = true;
    (async () => {
      setLoading(true);
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session?.access_token) {
          if (activo) { setEsSuperUsuario(false); setLoading(false); }
          return;
        }
        const resp = await fetch(buildApiUrl(`/auth/me?modulo_codigo=pina&empresa_id=${empresaId}`), {
          headers: { Authorization: `Bearer ${session.access_token}` },
        });
        const data = await resp.json().catch(() => null);
        if (activo) setEsSuperUsuario(Boolean(data?.usuario?.es_superusuario));
      } catch {
        if (activo) setEsSuperUsuario(false);
      } finally {
        if (activo) setLoading(false);
      }
    })();
    return () => { activo = false; };
  }, [empresaId]);

  return { esSuperUsuario, loading };
}
